export default "__VITE_ASSET__BWLF4uYv__"